// extracted by mini-css-extract-plugin
export var chip = "_qr-2";
export var chipBody = "_qr-8";
export var chipHeader = "_qr-9";
export var chipWithKind = "_qr-7";
export var icon = "_qr-3";
export var kind = "_qr-a";
export var remove = "_qr-5";
export var removeIcon = "_qr-6";
export var row = "_qr-0";
export var rowHistorical = "_qr-1";
export var text = "_qr-4";